import styled from '@emotion/styled';
import { Title } from 'components/Title';

export const StyledItemContainer = styled.li`
    padding: ${({ theme }) => theme.base.spacing[2]} 0;
    border-bottom: 1px solid ${({ theme }) => theme.base.color.separator};
    max-width: 100%;
    list-style: none;
`;

export const ItemContentContainer = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 90px;
`;

export const ItemTextContainer = styled.div`
    padding-top: ${({ theme }) => theme.base.spacing[1]};
    padding-right: ${({ theme }) => theme.base.spacing[4]};
    max-width: 70%;
`;

export const ItemTitle = styled(Title)`
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
`;

export const ItemDescription = styled.div`
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
`;

export const ProductImage = styled.div`
    height: 90px;
    min-width: 90px;
    background-position: center center;
    background-size: 100%;
    border-radius: ${({ theme }) => theme.base.radius.xl};
    background-repeat: no-repeat;
    background-size: cover;
`;
